import { render } from "./TextGeneratorPropsCmp.vue?vue&type=template&id=5dff8700"
import script from "./TextGeneratorPropsCmp.vue?vue&type=script&lang=js"
export * from "./TextGeneratorPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__